module.exports = __webpack_public_path__ + "static/media/supervisor.55a7ef1f.svg";